import "./style.css";

import {
  ComposedInputField,
  type ComposedInputFieldProps,
} from "../composedInputField/ComposedInputField";

type SsnInputProps = ComposedInputFieldProps & {
  id: string;
  useDefaultPopover?: boolean;
  popoverMessage?: string | null;
  label?: string;
  ref?: React.Ref<HTMLInputElement>;
};

export const SsnInput = ({
  useDefaultPopover,
  popoverMessage,
  onChange,
  ref,
  ...rest
}: SsnInputProps) => {
  const usedPopoverMessage =
    (useDefaultPopover && (
      <div className="if p-16">
        Tarvitsemme henkilötunnuksesi, jotta voimme näyttää sinulle tarkan
        hinnan alennuksineen. Osoitetietojasi käytetään hinnan laskemiseen ja
        voimme saada tiedot Ifin asiakasrekisteristä tai
        väestötietojärjestelmästä. Tarkistamme luottotietosi Suomen Asiakastieto
        Oy:stä. Henkilötunnuksen lähettäminen on suojattu TLS-turvatekniikalla.
        <br />
        <br />
        Mikäli olet vähintään 18-vuotias ja tarvitset vakuutusturvaa kattamaan
        kilpaurheilua tai riskialttiita lajeja, olethan yhteydessä
        asiakaspalveluumme 010 19 19 23.
      </div>
    )) ||
    popoverMessage;
  return (
    <ComposedInputField
      {...rest}
      ref={ref}
      popoverMessage={usedPopoverMessage}
      type={"text"}
      className="ssn-input"
      onChange={(e) => {
        if (onChange) {
          const { value } = e.target;
          const capitalizedValue = value?.toUpperCase();
          const syntheticEvent = {
            ...e,
            target: {
              ...e.target,
              value: capitalizedValue,
            },
          };
          onChange(syntheticEvent as React.ChangeEvent<HTMLInputElement>);
        }
      }}
    />
  );
};
